/**
 * Markets where a website "Imprint" (Impressum) link is legally required.
 *
 * Source of truth:
 * https://sportalliance.atlassian.net/wiki/spaces/~arne.reimer/pages/5842239582/Website+Imprint+Legal+Requirements+by+Market
 *
 * The imprint is mandatory across the EU (eCommerce Directive Art. 5), the EEA,
 * Switzerland, and the UK (Electronic Commerce Regulations 2002, post-Brexit).
 * It has no legal meaning in markets such as Australia, the USA, Canada, or the
 * UAE, where it should be hidden. Codes are ISO 3166-1 alpha-2.
 */
export const IMPRINT_REQUIRED_COUNTRY_CODES: ReadonlySet<string> = new Set([
    // EU-27
    'AT',
    'BE',
    'BG',
    'HR',
    'CY',
    'CZ',
    'DK',
    'EE',
    'FI',
    'FR',
    'DE',
    'GR',
    'HU',
    'IE',
    'IT',
    'LV',
    'LT',
    'LU',
    'MT',
    'NL',
    'PL',
    'PT',
    'RO',
    'SK',
    'SI',
    'ES',
    'SE',
    // EEA (non-EU)
    'IS',
    'LI',
    'NO',
    // Switzerland, United Kingdom, Monaco (follows French law)
    'CH',
    'GB',
    'MC'
]);

/**
 * Returns whether the given ISO alpha-2 country code belongs to a market where
 * the imprint link is legally required. Unknown or missing codes return `false`.
 */
export function isImprintRequiredCountry(code?: string): boolean {
    if (!code) {
        return false;
    }
    return IMPRINT_REQUIRED_COUNTRY_CODES.has(code.toUpperCase());
}
